import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { handlePostRequest } from "../../services/PostTemplate";
import { useDispatch } from "react-redux";
import LoadingOverlay from "react-loading-overlay";
import { Triangle } from "react-loader-spinner";
import { handleGetRequest } from "../../services/GetTemplate";
import { handleAuthRequest } from "../../services/Auth";
import './Login.scss'

const Login = () => {

    const [saveBtnLoading, setSaveBtnLoading] = useState(false)
    const [loadingIcon, setLoadingIcon] = useState('');
    const [isActive, setIsActive] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()

    const validationSchema = Yup.object().shape({
        email: Yup.string().email("Invalid email address").required("Email is required."),
        password: Yup.string().required("Password is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            email: "",
            password: "",
        },

        onSubmit: async (data) => {
            setLoadingIcon("pi pi-spin pi-spinner");
            setSaveBtnLoading(true);

            try {
                let obj = {
                    email: formik.values.email,
                    password: formik.values.password,
                }

                const response = await dispatch(handleAuthRequest(obj, "/api/v1/auth/login", true, true));

                // Check for successful response
                if (response?.statusCode === 200 || response?.status === 'success') {
                    localStorage.setItem("login", "true");
                    if (response?.data?.adminUser?._id) {
                        localStorage.setItem('userId', response?.data?.adminUser._id);
                    }
                    if (response?.data?.adminUser?.name || response?.data?.adminUser?.email) {
                        localStorage.setItem('name', response?.data?.adminUser?.name || response?.data?.adminUser?.email);
                    }
                    if (response?.data?.token) {
                        localStorage.setItem('token', response?.data?.token);
                    }

                    history.push("/categories");
                } else {
                    // Error case - loading states already reset by error handler
                    setSaveBtnLoading(false);
                    setLoadingIcon("");
                }
            } catch (error) {
                setSaveBtnLoading(false);
                setLoadingIcon("");
            } finally {
                // Ensure loading states are reset
                if (saveBtnLoading) {
                    setSaveBtnLoading(false);
                    setLoadingIcon("");
                }
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const RouteTo = () => {
        history.push("/forgotPassword")
    }

    useEffect(() => {
        if (formik.values.email) {
            localStorage.setItem("EmailForForgotPass", formik.values.email)
        }
    }, [formik.values.email])

    return (

        <>
            <LoadingOverlay
                active={isActive}
                spinner={<Triangle
                    height="120"
                    width="120"
                    color="#dc2626"
                    ariaLabel="triangle-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                />}
                styles={{
                    overlay: (base) => ({
                        ...base,
                        background: 'rgb(38 41 51 / 78%)',
                    })
                }}
            >
                <div className="login-page-container">
                    {/* Left Section with Food Theme Background */}
                    <div className="left-section">
                        <div className="left-section-overlay">
                            <div className="logo-container">
                                <div className="brand-logo-circle">
                                    <div className="brand-logo-inner">
                                        <span className="brand-text-grab">GRAB</span>
                                        <span className="brand-ampersand">&</span>
                                        <span className="brand-text-eat">EAT</span>
                                    </div>
                                </div>
                            </div>
                            <div className="food-decoration">
                                <div className="food-icon icon-1">🍔</div>
                                <div className="food-icon icon-2">🍕</div>
                                <div className="food-icon icon-3">🍜</div>
                                <div className="food-icon icon-4">🍛</div>
                                <div className="food-icon icon-5">🥗</div>
                                <div className="food-icon icon-6">🍰</div>
                            </div>
                        </div>
                    </div>

                    {/* Right Section with Login Form */}
                    <div className="right-section">
                        <form onSubmit={formik.handleSubmit} className="login-form">
                            <div className="login-header">
                                <h1 className="login-title">Grab & Eat</h1>
                                <p className="login-subtitle">Welcome back!</p>
                                <p className="login-description">Sign in to your admin account to continue</p>
                            </div>

                            <div className="login-form-fields">
                                <div className="input-card-login flex-column">
                                    <div className='input-label-row'>
                                        <label>Email</label>
                                        <span className="Label__Required">*</span>
                                    </div>
                                    <InputText
                                        className="p-inputtext-sm login-input"
                                        id="email"
                                        name="email"
                                        placeholder='Enter your email address'
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        type="email"
                                    />
                                    <span className="error-message">
                                        {getFormErrorMessage("email")}
                                    </span>
                                </div>

                                <div className="input-card-login flex-column">
                                    <div className='input-label-row'>
                                        <label>Password</label>
                                        <span className="Label__Required">*</span>
                                    </div>
                                    <Password
                                        placeholder="Enter your password"
                                        id="password"
                                        name="password"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        toggleMask
                                        autoComplete="off"
                                        feedback={false}
                                        className="w-full custom-password-field login-input"
                                    />
                                    <span className="error-message">
                                        {getFormErrorMessage("password")}
                                    </span>
                                </div>

                                {/*<div className="forgot-password-link" onClick={RouteTo}>
                                    Forgot Password?
                                </div>*/}

                                <div className='login-button-container'>
                                    <Button
                                        className="Login-Button"
                                        label="Login to Continue"
                                        iconPos="right"
                                        icon={loadingIcon || ""}
                                        loading={saveBtnLoading}
                                        type="submit"
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </LoadingOverlay>
        </>
    );
};

export default Login;
